<template>
  <div class="content">
    <h1 class="content__title" v-text="texts.title"></h1>
    <span class="content__details" v-text="texts.subtitle"></span>
    <div class="content__container">
      <main class="main">
        <section class="main__section">
          <h2 class="main__title">Datos de la Categoría de la Entrada</h2>

          <div class="waiting" v-if="loading">
            <img src="/static/img/waiting.gif" alt="Cargando Información" class="waiting__image">
          </div>

          <form class="form" @submit.prevent="saveCategory" v-if="!loading">
            <div class="form__fielset">

              <div class="form__container form__container--half">
                <label for="name_es" class="form__label form__label--required">Nombre de la categoría</label>
                <input type="text" class="form__input" name="name_es" id="name_es" placeholder="Nombre de la Categoría" v-model="category.name_es" v-validate="validation.name_es">
                <span v-show="errors.has('name_es')" class="form__alert">{{ errors.first('name_es') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="status_id" class="form__label form__label--required">Estatus</label>
                <div class="form__select-container">
                  <select name="status_id" id="status_id" class="form__select" v-validate="validation.status_id" v-model="category.status_id">
                    <option :value="null">Seleccionar Estatus</option>
                    <option v-for="(status, index) in statusList" :key="index" :value="status.id" v-text="status.name"></option>
                  </select>
                </div>
                <span v-show="errors.has('status_id')" class="form__alert">{{ errors.first('status_id') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="cover" class="form__label">Cover de la Categoría</label>
                <input-viewer name="cover" v-model="category.cover" v-validate="validation.cover"></input-viewer>
                <span v-show="errors.has('cover')" class="form__alert">{{ errors.first('cover') }}</span>
              </div>

              <input type="submit" class="btn btn__default btn--regular" :value="texts.submit">

            </div>
          </form>
        </section>
      </main>
      <aside class="sidebar">
        <h2 class="sidebar__title">NAVEGACIÓN</h2>
        <router-link class="btn btn--small btn__default" :to="{name: 'postCategoryList', params: {page: 1}}">Categorías</router-link>
        <router-link v-if="$route.name === 'postCategoryEdit'" class="btn btn--small btn__default" :to="{name: 'postCategoryNew'}">Nueva Categoría</router-link>
      </aside>
    </div>
  </div>
</template>

<script>
import httpService from '@/api/request'
import {validation, fields, statusList, texts} from './mocks'
import inputViewer from '@/components/media/input'
export default {
  mixins: [httpService],
  components: {inputViewer},
  data: function () {
    return {
      validation: validation,
      category: null,
      statusList: statusList
    }
  },
  created: function () {
    this.start()
  },
  watch: {
    '$route.path': function () {
      this.start()
    }
  },
  methods: {
    start: function () {
      if (this.categoryId) {
        this.getCategory()
      } else {
        this.category = new fields()
      }
    },
    getCategory: function () {
      let httpRequest = {
        params: '',
        module: 'post_categories'
      }
      this.getById(this.categoryId, httpRequest)
        .then(
          category => {
            this.category = category.data
            if (category.data.cover) {
              this.category.cover = JSON.parse(category.data.cover)
            }
          }
        )
        .catch(
          () => {
            this.$router.push({name: 'postCategoryNew'})
          }
        )
    },
    saveCategory: function () {
      this.$validator.validateAll()
        .then(
          response => {
            if (response) {
              let httpRequest = {
                params: '',
                module: 'post_categories',
                element: this.category
              }
              let request
              if (this.$route.name === 'postCategoryEdit') {
                request = this.put(this.categoryId, httpRequest)
              } else if (this.$route.name === 'postCategoryNew') {
                request = this.post(httpRequest)
              }
              request.then(
                response => {
                  this.$store.commit('notificate', {
                    title: this.texts.messages.success.title,
                    text: this.texts.messages.success.text,
                    type: 'success'
                  })
                  if (this.$route.name === 'postCategoryNew') {
                    this.$router.push({name: 'postCategoryEdit', params: {id: response.data.current_id}})
                  }
                }
              )
            } else {
              this.$store.commit('notificate', {
                title: 'CAMPOS REQUERIDOS',
                text: 'Por favor, revise el formulario, existen campos requeridos que no han sido completados.',
                type: 'warn'
              })
            }
          }
        )
    }
  },
  computed: {
    categoryId: function () {
      return this.$route.params.id
    },
    loading: function () {
      return this.$route.params.id && !this.category
    },
    texts: function () {
      return texts[this.$route.name]
    }
  }
}
</script>

<style lang="sass">
@import "../../assets/sass/objects/_btns"
@import "../../assets/sass/components/layout/_forms"
</style>



// WEBPACK FOOTER //
// src/components/post_categories/edit.vue